import { FormGroup } from '@angular/forms';
import { ConsultationStatus } from '@enums/consultation-status';
import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { Treatment } from '@enums/treatment';

import { BasicConsultationRequestRequest } from './basic-consultation-request-request';
import { ConsultationRequestAdditionalInfo } from './consultation-request-additional-info';
import { ConsultationRequestHelper } from './consultation-request-helper';

export class ConsultationRequestFormRequest extends BasicConsultationRequestRequest {
  public phone: string;
  public gender: string;
  public sex: string;
  public ethnicity?: string;
  public sex_with: string;
  public symptoms: string;
  public race?: string;
  public prescriptions: string;
  public terms: boolean;
  public additional_info: ConsultationRequestAdditionalInfo;
  public recharge: any;
  public user_id?: number;
  public treatment_for?: Treatment;

  public constructor(
    consultationRequestFormGroup: FormGroup,
    transactionId: string,
    treatmentType: ConsultationTreatmentTypes,
    gender: string,
    recharge: any,
  ) {
    const personal = consultationRequestFormGroup.get('personal')!.value;
    const contact = consultationRequestFormGroup.get('contact')!.value;
    const medicalHistory = consultationRequestFormGroup.get('medicalHistory')!.value;
    const prescription = consultationRequestFormGroup.get('prescription')!.value;
    const pharmacy = consultationRequestFormGroup.get('pharmacy')!.value;

    const { month, day, year } = personal.birthday;

    if (month == null || day == null || year == null) {
      throw new Error('Invalid birthday: month, day, and year are required');
    }

    super(
      transactionId,
      treatmentType,
      personal.firstName,
      personal.lastName,
      ConsultationRequestHelper.getDateDataString(personal.birthday),
      contact.email,
      ConsultationStatus.Incomplete,
      pharmacy.id,
      medicalHistory.allergies,
      medicalHistory.health_info,
    );

    this.treatment_for = prescription.treatment;
    this.additional_info = new ConsultationRequestAdditionalInfo(
      prescription.partner,
      prescription.treatment,
      personal,
    );

    this.ethnicity = medicalHistory.ethnicity;
    this.gender = gender;
    this.phone = contact.phone;
    this.prescriptions = medicalHistory.prescriptions;
    this.race = medicalHistory.race;
    this.recharge = recharge;
    this.sex = gender;
    this.sex_with = medicalHistory.sex_with;
    this.symptoms = ConsultationRequestHelper.getSymptomsArrayFromValues(medicalHistory.symptoms).join(', ');
    this.terms = consultationRequestFormGroup.get('terms')!.value;
  }
}
